var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 45,
    viewBox: "0 0 41 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V14.8077C2 17.9515 4.54853 20.5 7.69231 20.5C10.8361 20.5 13.3846 17.9515 13.3846 14.8077V6.26923C13.3846 4.69734 12.1103 3.42308 10.5385 3.42308C8.96659 3.42308 7.69231 4.69734 7.69231 6.26923V16.2308M17.6538 3.42308H36.1538C37.7258 3.42308 39 4.69734 39 6.26923V40.4231C39 41.995 37.7258 43.2692 36.1538 43.2692H7.69231C6.12043 43.2692 4.84615 41.995 4.84615 40.4231V24.7692M31.8846 14.8077H20.5M31.8846 23.3462H20.5M31.8846 31.8846H11.9615",
    stroke: "#353535",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.3bba636434903c670c40e03c6e0302ac.svg";
export { ForwardRef as ReactComponent };